import fe, { useState as pe, useRef as de, useEffect as ye, useCallback as me, useMemo as ve, createContext as be, useContext as he } from "react";
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var G = function() {
  return G = Object.assign || function(e) {
    for (var o, t = 1, s = arguments.length; t < s; t++) for (var f in o = arguments[t]) Object.prototype.hasOwnProperty.call(o, f) && (e[f] = o[f]);
    return e;
  }, G.apply(this, arguments);
}, z, ge = function(e) {
  var o;
  e ? function(t) {
    if (t) for (; t.lastChild; ) t.lastChild.remove();
  }(typeof e == "string" ? document.getElementById(e) : e) : (o = document.querySelector(".grecaptcha-badge")) && o.parentNode && document.body.removeChild(o.parentNode);
}, Se = function(e, o) {
  ge(o), window.___grecaptcha_cfg = void 0;
  var t = document.querySelector("#" + e);
  t && t.remove(), function() {
    var s = document.querySelector('script[src^="https://www.gstatic.com/recaptcha/releases"]');
    s && s.remove();
  }();
}, $e = function(e) {
  var o = e.render, t = e.onLoadCallbackName, s = e.language, f = e.onLoad, v = e.useRecaptchaNet, p = e.useEnterprise, m = e.scriptProps, a = m === void 0 ? {} : m, b = a.nonce, h = b === void 0 ? "" : b, u = a.defer, $ = u !== void 0 && u, y = a.async, P = y !== void 0 && y, g = a.id, S = g === void 0 ? "" : g, R = a.appendTo, C = S || "google-recaptcha-v3";
  if (function(c) {
    return !!document.querySelector("#" + c);
  }(C)) f();
  else {
    var w = function(c) {
      return "https://www." + (c.useRecaptchaNet ? "recaptcha.net" : "google.com") + "/recaptcha/" + (c.useEnterprise ? "enterprise.js" : "api.js");
    }({ useEnterprise: p, useRecaptchaNet: v }), l = document.createElement("script");
    l.id = C, l.src = w + "?render=" + o + (o === "explicit" ? "&onload=" + t : "") + (s ? "&hl=" + s : ""), h && (l.nonce = h), l.defer = !!$, l.async = !!P, l.onload = f, (R === "body" ? document.body : document.getElementsByTagName("head")[0]).appendChild(l);
  }
}, K = function(e) {
  typeof process < "u" && process.env && process.env.NODE_ENV !== "production" || console.warn(e);
};
(function(e) {
  e.SCRIPT_NOT_AVAILABLE = "Recaptcha script is not available";
})(z || (z = {}));
var B = be({ executeRecaptcha: function() {
  throw Error("GoogleReCaptcha Context has not yet been implemented, if you are using useGoogleReCaptcha hook, make sure the hook is called inside component wrapped by GoogleRecaptchaProvider");
} });
B.Consumer;
function _e(e) {
  var o = e.reCaptchaKey, t = e.useEnterprise, s = t !== void 0 && t, f = e.useRecaptchaNet, v = f !== void 0 && f, p = e.scriptProps, m = e.language, a = e.container, b = e.children, h = pe(null), u = h[0], $ = h[1], y = de(o), P = JSON.stringify(p), g = JSON.stringify(a == null ? void 0 : a.parameters);
  ye(function() {
    if (o) {
      var C = (p == null ? void 0 : p.id) || "google-recaptcha-v3", w = (p == null ? void 0 : p.onLoadCallbackName) || "onRecaptchaLoadCallback";
      return window[w] = function() {
        var l = s ? window.grecaptcha.enterprise : window.grecaptcha, c = G({ badge: "inline", size: "invisible", sitekey: o }, (a == null ? void 0 : a.parameters) || {});
        y.current = l.render(a == null ? void 0 : a.element, c);
      }, $e({ render: a != null && a.element ? "explicit" : o, onLoadCallbackName: w, useEnterprise: s, useRecaptchaNet: v, scriptProps: p, language: m, onLoad: function() {
        if (window && window.grecaptcha) {
          var l = s ? window.grecaptcha.enterprise : window.grecaptcha;
          l.ready(function() {
            $(l);
          });
        } else K("<GoogleRecaptchaProvider /> " + z.SCRIPT_NOT_AVAILABLE);
      } }), function() {
        Se(C, a == null ? void 0 : a.element);
      };
    }
    K("<GoogleReCaptchaProvider /> recaptcha key not provided");
  }, [s, v, P, g, m, o, a == null ? void 0 : a.element]);
  var S = me(function(C) {
    if (!u || !u.execute) throw new Error("<GoogleReCaptchaProvider /> Google Recaptcha has not been loaded");
    return u.execute(y.current, { action: C });
  }, [u, y]), R = ve(function() {
    return { executeRecaptcha: u ? S : void 0, container: a == null ? void 0 : a.element };
  }, [S, u, a == null ? void 0 : a.element]);
  return fe.createElement(B.Provider, { value: R }, b);
}
var Le = function() {
  return he(B);
};
function X(e, o) {
  return e(o = { exports: {} }, o.exports), o.exports;
  /** @license React v16.13.1
   * react-is.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
}
var i = typeof Symbol == "function" && Symbol.for, I = i ? Symbol.for("react.element") : 60103, V = i ? Symbol.for("react.portal") : 60106, E = i ? Symbol.for("react.fragment") : 60107, M = i ? Symbol.for("react.strict_mode") : 60108, N = i ? Symbol.for("react.profiler") : 60114, _ = i ? Symbol.for("react.provider") : 60109, L = i ? Symbol.for("react.context") : 60110, q = i ? Symbol.for("react.async_mode") : 60111, T = i ? Symbol.for("react.concurrent_mode") : 60111, A = i ? Symbol.for("react.forward_ref") : 60112, O = i ? Symbol.for("react.suspense") : 60113, Ce = i ? Symbol.for("react.suspense_list") : 60120, k = i ? Symbol.for("react.memo") : 60115, F = i ? Symbol.for("react.lazy") : 60116, we = i ? Symbol.for("react.block") : 60121, Pe = i ? Symbol.for("react.fundamental") : 60117, Re = i ? Symbol.for("react.responder") : 60118, xe = i ? Symbol.for("react.scope") : 60119;
function d(e) {
  if (typeof e == "object" && e !== null) {
    var o = e.$$typeof;
    switch (o) {
      case I:
        switch (e = e.type) {
          case q:
          case T:
          case E:
          case N:
          case M:
          case O:
            return e;
          default:
            switch (e = e && e.$$typeof) {
              case L:
              case A:
              case F:
              case k:
              case _:
                return e;
              default:
                return o;
            }
        }
      case V:
        return o;
    }
  }
}
function Q(e) {
  return d(e) === T;
}
var Ee = { AsyncMode: q, ConcurrentMode: T, ContextConsumer: L, ContextProvider: _, Element: I, ForwardRef: A, Fragment: E, Lazy: F, Memo: k, Portal: V, Profiler: N, StrictMode: M, Suspense: O, isAsyncMode: function(e) {
  return Q(e) || d(e) === q;
}, isConcurrentMode: Q, isContextConsumer: function(e) {
  return d(e) === L;
}, isContextProvider: function(e) {
  return d(e) === _;
}, isElement: function(e) {
  return typeof e == "object" && e !== null && e.$$typeof === I;
}, isForwardRef: function(e) {
  return d(e) === A;
}, isFragment: function(e) {
  return d(e) === E;
}, isLazy: function(e) {
  return d(e) === F;
}, isMemo: function(e) {
  return d(e) === k;
}, isPortal: function(e) {
  return d(e) === V;
}, isProfiler: function(e) {
  return d(e) === N;
}, isStrictMode: function(e) {
  return d(e) === M;
}, isSuspense: function(e) {
  return d(e) === O;
}, isValidElementType: function(e) {
  return typeof e == "string" || typeof e == "function" || e === E || e === T || e === N || e === M || e === O || e === Ce || typeof e == "object" && e !== null && (e.$$typeof === F || e.$$typeof === k || e.$$typeof === _ || e.$$typeof === L || e.$$typeof === A || e.$$typeof === Pe || e.$$typeof === Re || e.$$typeof === xe || e.$$typeof === we);
}, typeOf: d }, n = X(function(e, o) {
  process.env.NODE_ENV !== "production" && function() {
    var t = typeof Symbol == "function" && Symbol.for, s = t ? Symbol.for("react.element") : 60103, f = t ? Symbol.for("react.portal") : 60106, v = t ? Symbol.for("react.fragment") : 60107, p = t ? Symbol.for("react.strict_mode") : 60108, m = t ? Symbol.for("react.profiler") : 60114, a = t ? Symbol.for("react.provider") : 60109, b = t ? Symbol.for("react.context") : 60110, h = t ? Symbol.for("react.async_mode") : 60111, u = t ? Symbol.for("react.concurrent_mode") : 60111, $ = t ? Symbol.for("react.forward_ref") : 60112, y = t ? Symbol.for("react.suspense") : 60113, P = t ? Symbol.for("react.suspense_list") : 60120, g = t ? Symbol.for("react.memo") : 60115, S = t ? Symbol.for("react.lazy") : 60116, R = t ? Symbol.for("react.block") : 60121, C = t ? Symbol.for("react.fundamental") : 60117, w = t ? Symbol.for("react.responder") : 60118, l = t ? Symbol.for("react.scope") : 60119;
    function c(r) {
      if (typeof r == "object" && r !== null) {
        var j = r.$$typeof;
        switch (j) {
          case s:
            var x = r.type;
            switch (x) {
              case h:
              case u:
              case v:
              case m:
              case p:
              case y:
                return x;
              default:
                var H = x && x.$$typeof;
                switch (H) {
                  case b:
                  case $:
                  case S:
                  case g:
                  case a:
                    return H;
                  default:
                    return j;
                }
            }
          case f:
            return j;
        }
      }
    }
    var Y = h, Z = u, ee = b, oe = a, re = s, te = $, ne = v, ae = S, ce = g, ie = f, se = m, ue = p, le = y, D = !1;
    function J(r) {
      return c(r) === u;
    }
    o.AsyncMode = Y, o.ConcurrentMode = Z, o.ContextConsumer = ee, o.ContextProvider = oe, o.Element = re, o.ForwardRef = te, o.Fragment = ne, o.Lazy = ae, o.Memo = ce, o.Portal = ie, o.Profiler = se, o.StrictMode = ue, o.Suspense = le, o.isAsyncMode = function(r) {
      return D || (D = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), J(r) || c(r) === h;
    }, o.isConcurrentMode = J, o.isContextConsumer = function(r) {
      return c(r) === b;
    }, o.isContextProvider = function(r) {
      return c(r) === a;
    }, o.isElement = function(r) {
      return typeof r == "object" && r !== null && r.$$typeof === s;
    }, o.isForwardRef = function(r) {
      return c(r) === $;
    }, o.isFragment = function(r) {
      return c(r) === v;
    }, o.isLazy = function(r) {
      return c(r) === S;
    }, o.isMemo = function(r) {
      return c(r) === g;
    }, o.isPortal = function(r) {
      return c(r) === f;
    }, o.isProfiler = function(r) {
      return c(r) === m;
    }, o.isStrictMode = function(r) {
      return c(r) === p;
    }, o.isSuspense = function(r) {
      return c(r) === y;
    }, o.isValidElementType = function(r) {
      return typeof r == "string" || typeof r == "function" || r === v || r === u || r === m || r === p || r === y || r === P || typeof r == "object" && r !== null && (r.$$typeof === S || r.$$typeof === g || r.$$typeof === a || r.$$typeof === b || r.$$typeof === $ || r.$$typeof === C || r.$$typeof === w || r.$$typeof === l || r.$$typeof === R);
    }, o.typeOf = c;
  }();
}), U = (n.AsyncMode, n.ConcurrentMode, n.ContextConsumer, n.ContextProvider, n.Element, n.ForwardRef, n.Fragment, n.Lazy, n.Memo, n.Portal, n.Profiler, n.StrictMode, n.Suspense, n.isAsyncMode, n.isConcurrentMode, n.isContextConsumer, n.isContextProvider, n.isElement, n.isForwardRef, n.isFragment, n.isLazy, n.isMemo, n.isPortal, n.isProfiler, n.isStrictMode, n.isSuspense, n.isValidElementType, n.typeOf, X(function(e) {
  process.env.NODE_ENV === "production" ? e.exports = Ee : e.exports = n;
})), Me = { $$typeof: !0, compare: !0, defaultProps: !0, displayName: !0, propTypes: !0, type: !0 }, W = {};
W[U.ForwardRef] = { $$typeof: !0, render: !0, defaultProps: !0, displayName: !0, propTypes: !0 }, W[U.Memo] = Me;
export {
  B as GoogleReCaptchaContext,
  _e as GoogleReCaptchaProvider,
  Le as useGoogleReCaptcha
};
//# sourceMappingURL=contact-channels109.js.map
